var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vgp-button", {
        attrs: { label: _vm.locales("upgrade_rate_btn"), type: _vm.type },
        on: { onClick: _vm.upgradeClick },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }